import { DefaultState, TableDataResponse } from 'features/types';
import { Paging, SelectItem, Tab } from 'api/types';
import { ResourceBaseTableView } from 'components/ResourceBaseTableComponent/types';
import { ResourceEventRsvpStatuses } from 'features/resources/types';

export interface JobSeekerResourcesFiltersData {
  postTypeSelectList: SelectItem[];
  eventFormatSelectList: SelectItem[];
  resourceEventRsvpSelectList: SelectItem[];
}

export type JobSeekerResourcesTableRequestFiltersData = {
  text?: string;
  tab: string;
  postType?: string;
  assignedPrograms?: string[];
  fromDate?: string;
  toDate?: string;
  eventFormat?: string;
  jobSeekerEventRsvp?: string;
};

export type JobSeekerResourcesRequestData = {
  paging: Paging;
  filters: JobSeekerResourcesTableRequestFiltersData
};

export type JobSeekerResourcesState = DefaultState & {
  resourcesViewMode: ResourcesViewMode | undefined;
  currentFilters: GetJobSeekerResourcesTabsFilters;
  requestData: JobSeekerResourcesRequestData;
  data: {
    tableDataIsLoading: boolean;
    tabsIsLoading: boolean;
    tableData: TableDataResponse<JobSeekerResourcesTableView>;
    tabs: Tab[];
    filters: JobSeekerResourcesFiltersData | null;
  }
};

export type JobSeekerResourcesEnhancedFiltersForm = {
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  postType?: SelectItem | null;
  assignedPrograms?: SelectItem[];
  fromDate?: Date | null;
  toDate?: Date | null;
  eventFormat?: SelectItem | null;
  jobSeekerEventRsvp?: SelectItem | null;
}

export type JobSeekerResourcesTableFilters = JobSeekerResourcesEnhancedFiltersForm & {
  text?: string;
};

export type GetJobSeekerResourcesTabsFilters = JobSeekerResourcesTableFilters & {
  tab: string;
  postType?: SelectItem | null;
};

export type ResourceCommentForm = {
  id: string | undefined;
  postId: string;
  parentId: string;
  description: string;
};

export type ResourceEventRsvpForm = {
  status: ResourceEventRsvpStatuses;
};

export type JobSeekerResourcesTableView = ResourceBaseTableView & {
  descriptionText: string;
  authorLogo?: string;
  coverImage?: string;
  status: ResourceStatuses;
  isOwnPost: boolean;
  restrictedAdminPost: boolean;
  allowedToLike: boolean;
  allowedToComment: boolean;
  postLikes?: string[];
  postLiked: boolean;
  commentsAllowed: boolean;
  isPublicOnPcs?: boolean;
  pinnedToTop?: boolean;
  commentCount?: number;
  postCommented: boolean;
  fromDate?: string;
  toDate?: string;
  fromTime?: string;
  toTime?: string;
  withEndDate?: boolean;
  timezone?: string;
  timezoneAbbreviation: string;
  eventFormat?: string;
  jobSeekerEventRsvp?: string;
  jobSeekerEventRsvpForDisplay?: string;
  createdAt: Date;
};

export type SetResourceLike = {
  postLikes: string[],
  postLiked: boolean
};

export interface EventResourceRsvp {
  jobSeekerId: string;
  status: ResourceEventRsvpStatuses;
}

export type SetResourceEventRsvpFormData = {
  eventRsvps: EventResourceRsvp[];
  jobSeekerEventRsvp?: ResourceEventRsvpStatuses;
};

export enum ResourcesViewMode {
  Default = 'Default',
  Events = 'Events',
  ProductsAndServices = 'ProductsAndServices',
}

export enum ResourceStatuses {
  Published = 'Published',
  Archived = 'Archived',
}

export enum JobSeekerResourcesTabs {
  All = 'All',
  MyPosts = 'MyPosts',
  Archived = 'Archived',
}
